export default __webpack_public_path__ + "static/media/LOG-black.62f08f8f.svg";